// apolloClient.js
import { ApolloClient, InMemoryCache, HttpLink, from } from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import { onError } from "@apollo/client/link/error";
import { logout } from "./helpers/auth";

// Replace with your actual GraphQL endpoint
const httpLink = new HttpLink({
  uri: "https://cms.vidhaantextiles.com/graphql",
});

// Add the Authorization header
const authLink = setContext((_, { headers }) => {
  const token = localStorage.getItem("token"); // Or use any secure store
  return {
    headers: {
      ...headers,
      Authorization: token ? `Bearer ${token}` : "",
    },
  };
});

const errorLink = onError(({ graphQLErrors, networkError }) => {
  const networkStatus =
    networkError?.statusCode ?? networkError?.response?.status;

  const isUnauthorized =
    networkStatus === 401 ||
    graphQLErrors?.some((err) => {
      const code = err.extensions?.code;
      const exceptionStatus =
        err.extensions?.exception?.status ??
        err.extensions?.exception?.statusCode;
      return (
        code === "UNAUTHENTICATED" ||
        code === "UNAUTHORIZED" ||
        exceptionStatus === 401
      );
    });

  if (isUnauthorized) {
    logout();
  }
});

const client = new ApolloClient({
  link: from([authLink, errorLink, httpLink]),
  cache: new InMemoryCache(),
});

export default client;
